import { Fragment } from "react";
import { ShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/ShipmentState";
import { colorForShipmentState } from "@/Helpers/colorForShipmentState";

import { T } from "@freightsimple/ui-core/Typography/T";
import type { TrackingLine } from "@/Shared/Tracking/Helpers/trackingGroupLinesIntoDates";
import { groupLinesIntoDates } from "@/Shared/Tracking/Helpers/trackingGroupLinesIntoDates";
import TrackingTrackPiece from "@/Shared/Tracking/CustomComponents/TrackingTrackPiece";

interface TrackingTimelineProps {
  lines: Array<TrackingLine>;
  shipmentState: ShipmentState;
}

interface HeaderRowProps {
  color: string;
  date: string;
  first: boolean;
}

function HeaderRow_(props: HeaderRowProps) {
  return (
    <div className="flex h-[60px] flex-row items-end">
      <TrackingTrackPiece
        showCircle={false}
        connectTop={!props.first}
        connectBottom={!props.first}
        color={props.color}
        showArrow={false}
      />
      <T size="lg" weight="semibold" color="faint">
        {props.date}
      </T>
    </div>
  );
}

interface TimeRowProps {
  color: string;
  time: string;
  message: string;
  first: boolean;
  last: boolean;
  showArrows: boolean;
}

function TimeRow_(props: TimeRowProps) {
  const rows = Math.ceil(props.message.length / 50);
  return (
    <div
      className="flex flex-row items-start"
      style={{ height: 40 * rows + "px" }}
    >
      <TrackingTrackPiece
        showCircle={true}
        connectTop={!props.first}
        connectBottom={!props.last}
        color={props.color}
        showArrow={props.showArrows && props.first}
      />
      <div className="w-[112px]">
        <T size="lg" weight="semibold" color="muted">
          {props.time}
        </T>
      </div>
      <div className="max-w-[540px]">
        <T size="lg" color="muted">
          {props.message}
        </T>
      </div>
    </div>
  );
}

function TrackingTimeline(props: TrackingTimelineProps) {
  const groupedLines = groupLinesIntoDates(props.lines.reverse());

  const color = colorForShipmentState(props.shipmentState);

  return (
    <>
      {groupedLines.map((date, index) => {
        const firstDate = index === 0;
        const lastDate = index === groupedLines.length - 1;

        return (
          <Fragment key={`tracking-group-${date.dateDescription}`}>
            <HeaderRow_
              color={color}
              date={date.dateDescription}
              first={firstDate}
              key={`tracking-header-${date.dateDescription}`}
            ></HeaderRow_>
            {date.lines.map((line, lineIndex) => {
              const lastLine = date.lines.length - 1 === lineIndex;
              return (
                <TimeRow_
                  key={`tracking-time-${date.dateDescription}-${line.timeDescription}-${line.message}`}
                  color={color}
                  time={line.timeDescription}
                  message={line.message}
                  first={firstDate && lineIndex === 0}
                  last={lastDate && lastLine}
                  showArrows={props.shipmentState === ShipmentState.InTransit}
                ></TimeRow_>
              );
            })}
          </Fragment>
        );
      })}
    </>
  );
}
export default TrackingTimeline;
